import React from 'react';

const EmptyState = () => (
  <div className="cart-popup__empty">
    <p className="cart-popup__empty-title">Your cart is empty!</p>
    <p className="cart-popup__empty-description">
      You haven&apos;t added anything to your cart yet! Go ahead and check out our products.
      Then you can come right back to checkout.
    </p>
    <a href="/collections/shop-all" className="btn btn--primary btn--full-width btn--rounded">
      Shop All Products
    </a>
  </div>
);

export default EmptyState;
